<template>
  <v-container grid-list-md>
    <v-layout column>
      <v-flex>
        <v-card class="border-r-0">
          <v-toolbar class="elevation-0" color="gray">
            <v-toolbar-title>
              <h1 class="subheading">New Purchase</h1>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              color="info"
              @click="savePurchase"
              :disabled="Purchase.purchaseDetail.length === 0"
              >Save</v-btn
            >
          </v-toolbar>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm9>
                <v-text-field v-model="Purchase.vendorName" label="Vendor Name"></v-text-field>
              </v-flex>
              <v-flex xs12 sm3>
                <v-layout column>
                  <v-flex class="text-xs-right font-weight-regular title">
                    <span>Total</span>
                  </v-flex>
                  <v-flex class="display-1 font-weight-medium text-xs-right">
                    {{ total | currency }}
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card>
          <v-card-text>
            <v-layout row wrap align-center justify-space-between fill-height>
              <v-flex xs12 sm5>
                <v-autocomplete
                  v-model="selectedProduct"
                  :items="products"
                  item-text="productDetail"
                  return-object
                  :label="$t('labels.searchProduct')"
                >
                  <template slot="item" slot-scope="{ item }">
                    <span>{{ item.productDetail }}</span>
                    <v-spacer></v-spacer>
                    <v-chip v-if="item.trackInventory" dark color="info">
                      <span>{{ item.stock }}</span>
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm2>
                <v-text-field class="centered-input" label="Quantity" v-model="qty"></v-text-field>
              </v-flex>
              <v-flex xs12 sm2>
                <v-text-field class="right-input" label="Unit Cost" v-model="cost"></v-text-field>
              </v-flex>
              <v-flex xs12 sm2>
                <v-text-field class="right-input" label="Total" v-model="totalCost"></v-text-field>
              </v-flex>
              <v-flex d-flex xs12 sm1>
                <v-btn color="info" large @click="addRow" :disabled="!selectedProduct">
                  add
                </v-btn>
              </v-flex>
              <!-- <v-flex>
                
                <v-btn large icon color="info" @click="addRow" :disabled="!selectedProduct">
                  <v-icon>add</v-icon>
                </v-btn>
              </v-flex> -->
            </v-layout>
          </v-card-text>
        </v-card>
        <v-flex class="pa-0 pt-2">
          <v-card>
            <v-card-text>
              <v-flex xs12 sm4 offset-sm8>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  clearable
                >
                </v-text-field>
              </v-flex>
              <v-data-table
                :search="search"
                class="elevation-0 pa-0"
                :headers="headers"
                hide-actions
                :items="Purchase.purchaseDetail"
              >
                <template slot="items" slot-scope="props">
                  <tr>
                    <td>
                      <v-layout align-center justify-start row fill-height wrap>
                        <v-btn icon @click="deleteItem(props.item)">
                          <v-icon color="red">delete</v-icon>
                        </v-btn>
                        <span>{{ props.item.productDetail }}</span>
                      </v-layout>
                    </td>
                    <td class="text-xs-left">{{ props.item.serialNumber }}</td>
                    <td class="text-xs-center">{{ props.item.qty }}</td>
                    <td class="text-xs-right">{{ props.item.rate | currency }}</td>
                    <td class="text-xs-right">{{ props.item.total | currency }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-dialog persistent v-model="dialog" width="500">
      <v-card>
        <v-card-title>
          <span v-if="selectedProduct" class="headline"> {{ selectedProduct.productDetail }}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-progress-linear
          class="mt-0 mb-0"
          background-color="pink lighten-5"
          color="pink lighten-1"
          height="20"
          v-model="reOrderPercentage"
        >
          <div class="text-xs-center">{{ serialNumberList.length }} of {{ qty }}</div>
        </v-progress-linear>

        <v-card-text>
          <v-layout row>
            <v-flex>
              <v-text-field
                @keyup.enter.native="addSerial()"
                label="Serail Number"
                ref="serialNumber"
                v-model="serialNumber"
              ></v-text-field>
            </v-flex>
            <v-flex shrink>
              <v-btn large color="info" @click="addSerial" :disabled="!serialNumber">
                add
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-list  class="list-350">
          <template v-for="(row, index) in serialNumberList">
            <v-list-tile :key="index">
              <v-list-tile-avatar>
                <v-btn icon><v-icon color="red" @click="deleteNumber(index)">delete</v-icon></v-btn>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ row }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="serialNumberList.length < 0"
            flat
            @click="saveSerialRows"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import purchaseService from "../service";
import { mapGetters } from "vuex";

export default {
  name: "create-purchase",
  data() {
    return {
      search: null,
      focusable: false,
      dialog: false,
      reOrderPercentage: 0,
      qty: 1,
      cost: 0,
      totalCost: 0,
      serialNumber: null,
      selectedProduct: null,
      products: [],
      serialNumberList: [],
      headers: [
        {
          text: "Name",
          align: "left",
          value: "productDetail",
          sortable: true
        },
        {
          text: "Serial Number",
          align: "left",
          value: "serialNumber",
          sortable: true
        },
        {
          text: "Quantity",
          align: "center",
          value: "qty",
          sortable: true
        },
        {
          text: "Amount",
          align: "right",
          value: "rate",
          sortable: true
        },
        {
          text: "Total",
          align: "right",
          value: "total",
          sortable: true
        }
      ],
      Purchase: {
        vendorName: null,
        purchaseDetail: []
      }
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.serialNumber.focus();
        });
      }
    },
    cost(val) {
      this.totalCost = val * this.qty;
    },
    totalCost(val) {
      this.cost = val / this.qty;
    },
    qty(val) {
      this.cost = this.cost * val;
    }
  },
  created() {
    this.getHardware();
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    total() {
      let total = 0;
      this.Purchase.purchaseDetail.map(row => {
        total += row.total;
      });
      return total;
    }
  },
  methods: {
    savePurchase() {
      this.Purchase.userID = this.currentUser.userID;
      return purchaseService.create(this.Purchase).then(result => {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            type: "success",
            title: "Purchase created!"
          });

        this.$router.push("/inventory");
      });
    },
    saveSerialRows() {
      this.serialNumberList.map(row => {
        this.add({
          productID: this.selectedProduct.productID,
          productDetail: this.selectedProduct.productDetail,
          serialNumber: row,
          rate: this.cost,
          total: this.cost * 1,
          qty: 1
        });
      });
      this.emptyEntryBar();
      this.dialog = false;
    },
    closeDialog() {
      this.emptyEntryBar();
      this.dialog = false;
    },
    deleteNumber(i) {
      this.serialNumberList.splice(i, 1);
    },
    addSerial() {
      if (!this.serialNumber) return false;

      let index = this.serialNumberList.indexOf(this.serialNumber);

      if (index != -1) {
        this.$swal({
          title: "Already exist!",
          text: `${this.serialNumber} is already in this list`,
          type: "warning"
        });
        this.$refs.serialNumber.focus();
      } else {
        this.serialNumberList.unshift(this.serialNumber);
        this.reOrderPercentage = (this.serialNumberList.length / this.qty) * 100;
        this.serialNumber = null;
        this.$refs.serialNumber.focus();
      }
    },
    deleteItem(item) {
      const index = this.Purchase.purchaseDetail.indexOf(item);
      this.$swal({
        title: "Are you sure?",
        text: `You want to remove ${item.productDetail}.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      }).then(result => {
        if (result.value) {
          this.$Progress.start();
          this.Purchase.purchaseDetail.splice(index, 1);
          this.$Progress.finish();
        }
      });
      // confirm('Are you sure you want to delete this item?') && this.invoice.invoiceDetails.splice(index, 1)
    },
    emptyEntryBar() {
      this.qty = 1;
      this.cost = 0;
      this.totalCost = 0;
      this.selectedProduct = null;
    },
    add(data) {
      this.Purchase.purchaseDetail.push(data);
    },
    addRow() {
      if (this.selectedProduct.trackSerialNumber) {
        this.dialog = true;
      } else {
        this.add({
          productID: this.selectedProduct.productID,
          productDetail: this.selectedProduct.productDetail,
          rate: this.cost,
          total: this.totalCost,
          qty: this.qty
        });
        this.emptyEntryBar();
      }
    },
    getHardware() {
      return purchaseService.getHardware().then(result => {
        console.log("getHardware", result);
        this.products = result.data;
      });
    }
  }
};
</script>

<style scoped></style>
